
import { onClickOutside } from "@vueuse/core";
import { defineComponent, ref } from "vue";

export default defineComponent({
	props: {
		value: String,
		label: String,
		id: String,
	},
	setup(props) {
		const show = ref(false);
		const target = ref();
		const open = (event: any) => {
			show.value = true;
		};
		
		const close = () => {
			show.value = false;
			target.value.scrollIntoView({block: "center"});
		};

		onClickOutside(target, () => (show.value = false));

		const deactivate = (event: any) => {
			
			if (
				event.relatedTarget &&
				!event.relatedTarget.matches(`#${props.id}, #${props.id} *`) &&
				!event.relatedTarget.matches(`[name="discount"]`)
			) {
				if (show.value) {
						show.value = false;
				}
			}
		};
		
		return { show, target, open, deactivate, close };
	},
});
